module.exports = __webpack_public_path__ + "img/TESLA-Model-Y.032c7d9f.jpeg";